"use strict";
exports.__esModule = true;
exports.CommonExtType = void 0;
var CommonExtType;
(function (CommonExtType) {
    CommonExtType["WEB_PANEL"] = "mid_web_panel";
    CommonExtType["WEB_POPUP"] = "min_web_popup";
})(CommonExtType = exports.CommonExtType || (exports.CommonExtType = {}));
